export class KeyValue<T,Y> {
    key: T;
    value: Y;
}
export class KeyValueOpt<T, Y,U> {
    key: T;
    value: Y;
    opt: U;
}
